import React from 'react';

import {
  TitledActionContainer,
  TitledActionContainerHeader,
} from '../../../styles';

import AutomationToggles from './AutomationToggles';
import AutomationMacroPercentages from './AutomationMacroPercentages';
import AutomationTemplate from './AutomationTemplate';
import texts from './texts.json';

const MealPlanAutomation = () => (
  <TitledActionContainer>
    <TitledActionContainerHeader>{texts.header}</TitledActionContainerHeader>
    <AutomationToggles />
    <AutomationMacroPercentages />
    <AutomationTemplate />
  </TitledActionContainer>
);

export default MealPlanAutomation;
